import React, { useState, useEffect } from "react";
import ButtonLoader from "../../components/loader/ButtonLoader";
import { InputError } from "../../components/error/error";
import { Eye, EyeSlash } from "iconsax-react";

const ResetPassword = ({
  onClose,
  setShowSuccessModal,
  setShowConfirmPasswordPopup,
  onConfirm,
  setFormValues,
  formValues,
  isLoading,
}) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  useEffect(() => {
    if (password || confirmPassword) {
      setError("");
    }
  }, [password, confirmPassword]);

  const handleConfirm = () => {
    if (!validateInputs()) {
      return;
    }
    onConfirm();
    setShowConfirmPasswordPopup(false);
  };

  const validateInputs = () => {
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return false;
    }
    if (password.length > 15) {
      setError("Password cannot be more than 15 characters.");
      return false;
    }

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).+$/;
    if (!passwordRegex.test(password)) {
      setError(
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character."
      );
      return false;
    }

    if (password !== confirmPassword) {
      setError("Password and Confirm Password do not match.");
      return false;
    }

    return true;
  };

  const handleCancel = () => {
    setPassword("");
    setConfirmPassword("");
    setError("");
    onClose();
    setShowSuccessModal(false);
  };

  return (
    <div className="model">
      <div className="bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg w-full max-w-md min-h-40 py-8 px-6 mx-auto relative">
        <h2 className="text-xl font-medium text-primaryBlack font-Montserrat mb-3 text-center">
          Enter New Password
        </h2>
        <div className="flex flex-col gap-2">
          {/* Password Input */}
          <div className="relative w-full">
            <input
              type={passwordVisible ? "text" : "password"}
              name="password"
              placeholder="Password*"
              className={`border bg-white font-Proxima ${
                error ? "border-red" : "border-borderTheme/80"
              } px-4 py-2 rounded w-full`}
              onChange={(e) => {
                setFormValues({
                  id: formValues?.id,
                  password: e.target.value,
                  confirmPassword: formValues?.confirmPassword,
                });
                setPassword(e.target.value);
              }}
              value={password}
              autoComplete="new-password"
            />
            <span
              className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={() => setPasswordVisible(!passwordVisible)}
            >
              {passwordVisible ? <EyeSlash /> : <Eye />}{" "}
            </span>
          </div>
          {/* Confirm Password Input */}
          <div className="relative">
            <input
              type={confirmPasswordVisible ? "text" : "password"}
              name="confirmPassword"
              placeholder="Confirm New Password*"
              className={`border font-Proxima ${
                error ? "border-red" : "border-borderTheme/80"
              } px-4 py-2 rounded w-full`}
              onChange={(e) => {
                setFormValues({
                  id: formValues?.id,
                  password: formValues?.password,
                  confirmPassword: e.target.value,
                });
                setConfirmPassword(e.target.value);
              }}
              value={confirmPassword}
            />
            <span
              className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={() => setConfirmPasswordVisible(!confirmPasswordVisible)}
            >
              {confirmPasswordVisible ? <EyeSlash /> : <Eye />}{" "}
            </span>
          </div>

          {error && <InputError errorTitle={error} />}
          <div className="flex justify-end gap-3 pt-3">
            <button
              type="button"
              className="text-themeBtn  flex items-center uppercase font-Proxima justify-center px-6 py-1.5 rounded border border-themeBtn"
              onClick={handleCancel}
            >
              <span>Cancel</span>
            </button>
            <button
              type="button"
              className={`flex items-center justify-center px-6 py-1.5 rounded font-Proxima uppercase ${
                isLoading
                  ? "bg-disableThemeBtn"
                  : "border-2 border-themeBtn rounded text-white bg-themeBtn"
              }`}
              disabled={isLoading}
              onClick={handleConfirm}
            >
              {isLoading ? (
                <ButtonLoader removeTheme={true} />
              ) : (
                <span>Confirm</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
